import { AppButton } from 'components';
import { Fragment, memo, useState } from 'react';
import ReorderBlocks from './ReorderBlocks';

// This is currently applicable in notes & geek corner only
function RearrangeBlocks({ blocks, type, checkPrerequisite, handleSubmission }) {
  const [reOrderModal, setReOrderModal] = useState({ open: false, data: {} });

  return (
    <Fragment>
      {reOrderModal.open && (
        <ReorderBlocks
          open={reOrderModal.open}
          closeModal={() => {
            setReOrderModal({ open: false, data: {} });
          }}
          data={{
            blocks,
            type,
            handleSubmission: (args = {}) => {
              args.cb = () => setReOrderModal({ open: false, data: {} });
              handleSubmission(args);
            },
          }}
        />
      )}
      <AppButton
        variantClass="btn-plane g--tint m-2"
        onClick={() => {
          const { canGoForward } = checkPrerequisite?.() ?? {};
          if (!canGoForward) {
            window.alert('Please save the changes first and then proceed to reordering!');
            return;
          }

          setReOrderModal({ open: true, data: {} });
        }}
      >
        Reorder
      </AppButton>
    </Fragment>
  );
}

RearrangeBlocks.defaultProps = {
  blocks: [],
  type: '',
  handleSubmission: () => {},
};

export default memo(RearrangeBlocks);
